import TextField from '@maison/components/form/fields/TextField.vue';
import fieldMixin from '@maison/mixins/fieldMixin';

export default {
  components: { TextField },

  mixins: [fieldMixin],

  data() {
    return {
      showPassword: false,
    };
  },

  computed: {
    fieldType() {
      return this.showPassword ? 'text' : this.field.type;
    },

    fieldAttrs() {
      return { ...this.field, type: this.fieldType };
    },

    togglePasswordIcon() {
      return this.showPassword ? 'eyes-off-16' : 'eyes-on-16';
    },

    togglePasswordText() {
      return this.$t(this.showPassword ? 'Form.password.hide' : 'Form.password.show');
    },
  },

  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
  },
};
